import { CustomCollapseCard, Text, AddCarTypeSkeleton } from '@src/components';
import { Radio } from 'antd';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import { useDispatch, useSelector } from 'react-redux';
import { getVehicleDeviceTypeList, setSelectVehicleProviderType, setSelectCustomerVousList } from "@src/store/slice/addNewCarStore/addCarTypeSlice";
import '@src/styles/addNewCar/addCarSelectFuelProvider.scss';


const AddCarSelectFuelProvider = ({ customerVousList }) => {
  const isMobil = useMediaQuery({ query: '(max-width: 768px)' });
  const dispatch = useDispatch();
  const [value, setValue] = useState(1);
  const loading = useSelector((state) => state.addCarType.loading.customerVousList);

  const handleCarSelectFuelProviderChanged = async (e) => {
    const newValue = e.target.value;
    const selectCustomerVousList = customerVousList.find(list => list.vouId === newValue)
    setValue(e.target.value);
    await dispatch(getVehicleDeviceTypeList({ customerId: customerVousList[0]?.customerId, vouId: e.target.value }));
    await dispatch(setSelectVehicleProviderType(e.target.value));
    await dispatch(setSelectCustomerVousList(selectCustomerVousList));
  };

  return (
    <CustomCollapseCard
      className="add-car-select-fuel-provider-collapse"
      bodyCenter={!isMobil}
      cardTitle={<Text t="carSelectFuelProvider" />}
      cardTitleAlign="center"
    >
      {loading ? (
        <AddCarTypeSkeleton />
      ) : (
        <Radio.Group
          id="ticket-car-select-fuel-provider-radio-group"
          onChange={handleCarSelectFuelProviderChanged}
          value={value}
          className="add-car-select-fuel-provider-content"
        >
          {map(customerVousList, customer => (
            <Radio id={`ticketcar-${customer.vouId}`} value={customer.vouId} key={customer.vouId} aria-label={customer.vouId}>
              <div className="new-order-draft">
                <Text t={customer.vouName} />
              </div>
            </Radio>
          ))}
        </Radio.Group>
      )}
    </CustomCollapseCard>
  );
};

AddCarSelectFuelProvider.propTypes = {
  customerVousList: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default AddCarSelectFuelProvider;
